import React from 'react'
import Home from './components/Home'

export default function App() {
  window.document.body.style.backgroundColor = "#161212"
  return (
    <>
      <Home />
    </>
  )
}
